// src\v2\hooks\useEnumApi.js

import { useCallback, useEffect, useState } from "react";
import { enumApiService } from "../services/enumApiService";
import { transformEnumData } from "../../utils/textUtils";

export function useEnumsApi() {
  const [maintenanceTypes, setMaintenanceTypes] = useState([]);
  const [approverMaintenanceTypes, setApproverMaintenanceTypes] = useState([]);
  const [taxTreatmentsEnum, setTaxTreatments] = useState([]);
  const [salaryAdvanceTypes, setSalaryAdvanceTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  const fetchMaintenanceTypes = useCallback(async () => {
    try {
      setLoading(true);
      const data = await enumApiService.getMaintenanceTypes();
      setMaintenanceTypes(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMaintenanceTypes(); }, [fetchMaintenanceTypes]);

  const fetchApproverMaintenanceTypes = useCallback(async () => {
    try {
      setLoading(true);
      const data = await enumApiService.getApproverMaintenanceTypes();
      setApproverMaintenanceTypes(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchApproverMaintenanceTypes(); }, [fetchApproverMaintenanceTypes]);

  const fetchTaxTreatmentsEnum = useCallback(async () => {
    try {
      setLoading(true);
      const data = await enumApiService.getTaxTreatments();
      const taxTreatmentsTransformed = transformEnumData(data);
      setTaxTreatments(taxTreatmentsTransformed);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchTaxTreatmentsEnum(); }, [fetchTaxTreatmentsEnum]);

  const fetchSalaryAdvanceTypes = useCallback(async () => {
    try {
      setLoading(true);
      const data = await enumApiService.getSalaryAdvanceTypes();
      const salaryAdvanceTypesTransformed = transformEnumData(data);
      setSalaryAdvanceTypes(salaryAdvanceTypesTransformed);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchSalaryAdvanceTypes(); }, [fetchSalaryAdvanceTypes]);

  const fetchMaintenanceData = useCallback(async (typeIds) => {
    if (!typeIds || typeIds.length === 0) return {};
    try {
      setLoading(true);
      const data = await enumApiService.getMaintenanceData(typeIds);
      return data;
    } catch (err) {
      setError(err.message);
      return {};
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchMaintenanceDetailedData = useCallback(async (typeIds) => {
    if (!typeIds || typeIds.length === 0) return {};
    try {
      setLoading(true);
      return await enumApiService.getMaintenanceDetailedData(typeIds);
    } catch (err) {
      setError(err.message);
      return {};
    } finally {
      setLoading(false);
    }
  }, []);


  return {
    maintenanceTypes,
    approverMaintenanceTypes,
    taxTreatmentsEnum,
    salaryAdvanceTypes,
    loading,
    error,
    fetchMaintenanceTypes,
    fetchApproverMaintenanceTypes,
    fetchTaxTreatmentsEnum,
    fetchSalaryAdvanceTypes,
    fetchMaintenanceData,
    fetchMaintenanceDetailedData
  };
}